import { useState } from 'react'
import './network.scss'
import {
  AgxColumn,
  AgxSelect,
  useDebouncedState,
} from '@urbanx/agx-ui-components'
import ExportDropdown from './ExportDropdown'

import NetworkTable from './NetworkTable'
import FilterDropdown from './FilterDropdown'
import DateRangeSelector from './DateRangeSelector'
import { PageLayout } from 'layout'
import dayjs from 'dayjs'
import useExecutiveGetNetworkMetrics, {
  NetworkReportType,
} from 'services/functions/rex/reporting/useExecutiveGetNetworkMetrics'
import {
  ContractDateToUse,
  GetMetricsRequestTimePeriod,
} from '@urbanx/agx.rex.client'
import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2'

const DateOptions = [
  { value: GetMetricsRequestTimePeriod.Month, label: 'Month' },
  { value: GetMetricsRequestTimePeriod.Quarter, label: 'Quarter' },
  { value: GetMetricsRequestTimePeriod.Annual, label: 'Year' },
  { value: GetMetricsRequestTimePeriod.Previous, label: 'Last 12 Months' },
  { value: GetMetricsRequestTimePeriod.Custom, label: 'Custom' },
]

const Network = () => {
  const [networkSelectedTab, setNetworkSelectedTab] = useState(
    NetworkReportType.State
  )
  const [selectedFilter, setSelectedFilter] = useState(
    ContractDateToUse.Unconditional
  )
  const [selectedDateType, setSelectedDateType] =
    useState<GetMetricsRequestTimePeriod>(GetMetricsRequestTimePeriod.Month)

  const [{ startDate, endDate }, setSelectedDate] = useDebouncedState<{
    startDate: string
    endDate: string
  }>(
    {
      startDate: dayjs().format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD'),
    },
    500
  )

  const { data: statistics, isPending } = useExecutiveGetNetworkMetrics(
    networkSelectedTab,
    selectedFilter,
    startDate,
    endDate,
    selectedDateType
  )

  return (
    <PageLayout
      agentName={''}
      primaryPageTitle="Reporting"
      currentPageTitle="Network"
    >
      <div className="network-background">
        <AgxColumn extraClasses="executive-dashboard-content">
          <AgxSpacer direction='horizontal' contentJustification='space-between' contentAlignment='center'>
            <AgxSpacer direction='horizontal' contentJustification='start' contentAlignment='center' gap='sm'>
              <AgxTypography id={'networkStateHeaderTab'} type={networkSelectedTab === NetworkReportType.State ? 'body_ui_strong' : 'body_ui'} size={'medium'}
                color={networkSelectedTab === NetworkReportType.State ? 'var(--text-black)' : 'var(--text-primary)'}
                onClick={() => setNetworkSelectedTab(NetworkReportType.State)}>
                State
              </AgxTypography>
              <AgxTypography id={'networkStateHeaderTab'} type={networkSelectedTab === NetworkReportType.PartnershipLevel ? 'body_ui_strong' : 'body_ui'} size={'medium'}
                color={networkSelectedTab === NetworkReportType.PartnershipLevel ? 'var(--text-black)' : 'var(--text-primary)'}
                onClick={() => setNetworkSelectedTab(NetworkReportType.PartnershipLevel)}>
                Partnership Level
              </AgxTypography>
            </AgxSpacer>
            <AgxSpacer direction='horizontal' contentAlignment='center' contentJustification='end' gap='sm' fill>
              <FilterDropdown
                selectedFilter={selectedFilter}
                setSelectedFilter={setSelectedFilter}
              />
              <AgxSelect
                id="networkDateType"
                options={DateOptions}
                defaultValue={DateOptions[0]}
                onValueChanged={({ value }) => {
                  setSelectedDateType(
                    value as unknown as GetMetricsRequestTimePeriod
                  )
                }}
                noHeader
              />
              {selectedDateType === GetMetricsRequestTimePeriod.Custom && (
                <DateRangeSelector
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(dates) => {
                    setSelectedDate(dates)
                  }}
                />
              )}
              <ExportDropdown
                contractDateToUse={selectedFilter}
                fromDate={startDate}
                networkMetrics={networkSelectedTab}
                statistics={statistics?.metrics}
                timePeriod={selectedDateType}
                toDate={endDate}
              />
            </AgxSpacer>
          </AgxSpacer>
          <NetworkTable statistics={statistics} isPending={isPending} />
        </AgxColumn>
      </div>
    </PageLayout>
  )
}

export default Network
